module.exports = __webpack_public_path__ + "img/Metastasis-GBM_10X_WTA.e3cbd142.png";